var dateFormV2 = function(elementid,form,options={}){
    this.elementid =elementid;
    this.element = document.getElementById(elementid);
    this.form = form;

    this.layout();
    this.events();

};

dateFormV2.prototype.events = function(){
    var addDate = document.querySelector(".dateForm_addDate");
    if(addDate){
        addDate.addEventListener("click",(e)=>{
            e.preventDefault();
            this.layoutField();
        });
    }
};

dateFormV2.prototype.layout = function(){

    this.table = document.createElement("table");
    this.table.classList.add("dateTable");
    this.element.append(this.table);

    var i = 0;
    while(i < 30){
        this.layoutField();
        i++;
    }

};

dateFormV2.prototype.layoutField = function(){
    var row = document.createElement("tr");
    
    var dateCell = document.createElement("td");
    var dateField = document.createElement("input");
    dateField.classList.add("dateField");
    dateField.setAttribute("type","date");
    dateCell.append(dateField);
    row.append(dateCell);

    var startCell = document.createElement("td");
    var startField = document.createElement("input");
    startField.classList.add("startTime");
    startField.setAttribute("type","time");
    startCell.append(startField);
    row.append(startCell);

    var endCell = document.createElement("td");
    var endField = document.createElement("input");
    endField.classList.add("endTime");
    endField.setAttribute("type","time");
    endCell.append(endField);
    row.append(endCell);

    this.table.append(row);
};

dateFormV2.prototype.getValues = function(){
    var rows = this.table.querySelectorAll("tr");
    var values = [];
    rows.forEach(r=>{
        var dateField = r.querySelector(".dateField").value;
        var startTime = r.querySelector(".startTime").value;
        var endTime = r.querySelector(".endTime").value;
        if(dateField && dateField !== ""){
            var [year,month,date] = dateField.split("-");
            var dateObj = new Date();
            dateObj.setUTCFullYear(year);
            dateObj.setUTCMonth(month-1);
            dateObj.setUTCDate(date);
            dateObj.setUTCHours(0);
            dateObj.setUTCMinutes(0);
            dateObj.setUTCSeconds(0);
            dateObj.setUTCMilliseconds(0);

            var [startHour,startMinutes] = startTime.split(":");
            var startTS = (startHour*60*60)+(startMinutes*60);

            var [endHour,endMinutes] = endTime.split(":");
            var endTS = (endHour*60*60)+(endMinutes*60);
            values.push({
                date:month + "-" + date + "-" + year,
                startTime:startTS*1000,
                endTime:endTS*1000,
                timestamp:dateObj.getTime()
            });
        }

    });

    return values;
};